"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmexLoadingButton = void 0;
const material_1 = require("@mui/material");
exports.AmexLoadingButton = (0, material_1.styled)(material_1.Button)(({ theme }) => ({
    width: '100%',
    fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
}));
